module.exports = __webpack_public_path__ + "html/subscription-router-modals-container_4b2639ec9693db06edec20cad7c8ffa1.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/settings/subscription/containers/subscription-router-modals-container.html
// module id = 4Yp3
// module chunks = 64